import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import axios from 'axios';
import { WEBSERVICE_IP } from '../../functions/roots/webserviceIP';

const TiempoPorSemana = () => {
  const [datos, setDatos] = useState([]);
  const usuarioId = sessionStorage.getItem('usuarioId');

  useEffect(() => {
    const fetchTiempo = async () => {
      try {
        const res = await axios.get(`${WEBSERVICE_IP}/reportes/grafica/tiempo-por-semana/${usuarioId}`);
        const { semanas, tiempos } = res.data;

        const formateado = semanas.map((semana, i) => ({
          semana,
          minutos: tiempos[i]
        }));

        setDatos(formateado);
      } catch (error) {
        console.error('Error al obtener tiempo por semana:', error);
      }
    };

    if (usuarioId) fetchTiempo();
  }, [usuarioId]);

  return (
    <>
      {datos.length > 0 ? (
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={datos} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="semana" />
            <YAxis label={{ value: 'Minutos', angle: -90, position: 'insideLeft' }} />
            <Tooltip />
            <Line type="monotone" dataKey="minutos" stroke="#4f46e5" strokeWidth={2} dot={{ r: 4 }} />
          </LineChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-center text-gray-500">Cargando datos...</p>
      )}
    </>
  );
};

export default TiempoPorSemana;
